import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";

interface LottieAnimationProps {
  animationPath: string;
  color?: string;
  loop?: boolean;
  LoadingText?: string;
  onClick?: () => void;
  isFullscreen?: boolean;
  onComplete?: () => void;
  style?: React.CSSProperties;
}

const LottieAnimation: React.FC<LottieAnimationProps> = ({
  animationPath,
  color = "#ffffff",
  loop = true,
  LoadingText,
  onClick,
  style,
  isFullscreen,
  onComplete = () => { },
}) => {
  const [animationData, setAnimationData] = useState<any>(null);

  console.log("Lottie Animation :: ",animationPath)

  useEffect(() => {
    const fetchAnimationData = async () => {
      try {
        const response = await fetch(animationPath);
        const data = await response.json();
        setAnimationData(data);
      } catch (error) {
        console.error("Error loading animation data:", error);
      }
    };

    fetchAnimationData();
  }, [animationPath]);

  if (!animationData) {
    return <div>{LoadingText ? LoadingText : "Loading Animation..."}</div>;
  }

  return (
    <div
      style={
        isFullscreen
          ? {
            position: "absolute",
            inset: 0,
            objectFit: "fill",
            zIndex: 0,
            pointerEvents: "none",
            ...style, // ← merge custom styles
          }
          : {
            objectFit: "fill",
            maxWidth: "10vmin",
            
            margin: "0 auto",
            ...style, // ← merge custom styles
          }
      }
    >
      <Lottie
        animationData={animationData}
        loop={loop}
        onComplete={onComplete}
        onClick={onClick}
        style={isFullscreen ? { width: "100%", height: "100%" } : {}}
      />
    </div>
  );

};

export default LottieAnimation;
